
export enum ModalButtons { OK = 0, OKCancel = 1, YesNo = 2};
export enum ModalResult { OK = 0, Cancel = 1 };
export enum FormModus { New = 0, Edit = 1, Delete = 2, ReadOnly = 3 };